
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { getRequest } from '@/libs/utils.js'
import { getaddlog } from '@/api/hgfw'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import defautphoto from '@/assets/timg.jpg'
import banner from '@/assets/jifenhuangou/banner.png'
import title1 from '@/assets/jifenhuangou/title-bg1.png'
import title2 from '@/assets/jifenhuangou/title-bg2.png'
import photo from '@/assets/jifenhuangou/photo.png'
import jinpai from '@/assets/jifenhuangou/ico-paihang1.png'
import yinpai from '@/assets/jifenhuangou/ico-paihang2.png'
import tongpai from '@/assets/jifenhuangou/ico-paihang3.png'
import wujiaoxing1 from '@/assets/jifenhuangou/ico-wjx1.png'
import wujiaoxing2 from '@/assets/jifenhuangou/ico-wjx2.png'
import jp1 from '@/assets/jifenhuangou/jp-01.jpg'
import jp2 from '@/assets/jifenhuangou/jp-02.png'
import jp3 from '@/assets/jifenhuangou/jp-03.png'
import jp4 from '@/assets/jifenhuangou/jp-04.png'
import { selectCreditParty, exchangeCreditParty, getCreditAccountByTime, getCreditDetailCount, view } from '@/api/jfhl.js'
import { getTime } from '@/api/sys.js'
import config from '@/config'
export default {
name: 'jfhlIndex',
components: {
Flexbox,
FlexboxItem,
XButton
},
data () {
return {
banner: banner,
baseUrl: config.baseUrl,
defautphoto: defautphoto,
title1: title1,
title2: title2,
photo: this.$store.state.user.personObj.iconimgPATH,
jinpai: jinpai,
yinpai: yinpai,
tongpai: tongpai,
swiperOption: {
pagination: {
el: '.swiper-pagination'
},
slidesPerView: 3,
autoplay: {
delay: 1000,
disableOnInteraction: false
},
spaceBetween: 10,
loop: true,
freeMode: true
},
wjxList: [{
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}, {
img: wujiaoxing2
}],
prizeList: [{
url: 'javascript:',
img: jp1,
title: '司顿24cm珐琅锅'
}, {
url: 'javascript:',
img: jp2,
title: 'BOBOT手持无线吸尘器'
}, {
url: 'javascript:',
img: jp3,
title: '碧然德滤水壶'
}, {
url: 'javascript:',
img: jp4,
title: '保洁家庭清洁系列'
}],
partynum: 0,
signnum: 0,
rednum: 0,
partyused: ['', '', ''],
redused: ['', '', ''],
signused: ['', '', ''],
allget: 0,
acctname: this.$store.state.user.personObj.acctname,
paihangList: [],
ranking: 0,
partyid: getRequest().partyid,
starttime: '',
endtime: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120104
}).then(res => {
})
},
getStartTime () {
getTime({}).then(res => {
this.starttime = res.obj[1].value.slice(0, 10)
this.endtime = res.obj[2].value.slice(0, 10)
this.getTotal()
this.getPaihang()
})
},
selectCredit () {
selectCreditParty({
accoutid: this.accountid
}).then(res => {
if (res.success) {
this.partynum = res.obj.partynum
this.signnum = res.obj.signnum
this.rednum = res.obj.rednum
if (res.obj.partyused != '') {
this.partyused = res.obj.partyused.split(',')
}
if (res.obj.redused != '') {
this.redused = res.obj.redused.split(',')
}
if (res.obj.signused != '') {
this.signused = res.obj.signused.split(',')
}
this.wjxList.forEach((item, index) => {
if (index < this.partynum) {
item.img = wujiaoxing1
}
})
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})
},
getIntegral (credittype, num, level) {
exchangeCreditParty({
accoutid: this.accountid,
credittype: credittype,
credit: num,
level: level
}).then(res => {
if (res.success) {
let _this = this
this.$vux.confirm.show({
content: '您已经领取成功！',
showCancelButton: false,
onConfirm () {
if (credittype === 1) {
_this.$set(_this.partyused, level - 1, level)
} else if (credittype === 2) {
_this.$set(_this.signused, level - 1, level)
} else if (credittype === 3) {
_this.$set(_this.redused, level - 1, level)
}
_this.getTotal()
_this.getPaihang()
}
})
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})
},
getTotal () {
getCreditAccountByTime({
accountid: this.accountid,
starttime: this.starttime,
endtime: this.endtime
}).then(res => {
this.allget = res.obj.allget
})
},
getPaihang () {
getCreditDetailCount({
starttime: this.starttime,
endtime: this.endtime
}).then(res => {
if (res.success) {
this.paihangList = res.obj
this.paihangList.forEach((item, index) => {
if (item.accountid === this.accountid) {
this.ranking = index + 1
}
})
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})
},
getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
})
}
},
created () {
this.getAdd()
this.getStartTime()
this.getview()
this.selectCredit()
}
}
